module.exports = __webpack_public_path__ + "gamification.7c22995e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/gamification.jpg
// module id = 921
// module chunks = 0